import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';
import { useAuthStore } from '../../../store/storeAuth';
import type { IntegrationProviderConfig } from '../types';
import type { ThirdPartyMode } from '../types';
import Label from '../../UI/Label/Label';

interface ModeToggleProps {
  mode: ThirdPartyMode;
  onChange: (mode: ThirdPartyMode) => void;
  config: IntegrationProviderConfig | undefined;
  disabled?: boolean;
}

const ModeToggle: React.FC<ModeToggleProps> = ({
  mode,
  onChange,
  config,
  disabled,
}) => {
  const { user } = useAuthStore(state => state);

  if (!config) return null;
  if (config.supportsPull && !config.supportsPush) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Label labelName="Mode" isAdvanced sx={{ mb: 0 }} />
        <Box sx={{ fontSize: '14px', color: '#98A2B3' }}>Pull only</Box>
      </Box>
    );
  }
  if (!config.supportsPull && config.supportsPush) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Label labelName="Mode" isAdvanced sx={{ mb: 0 }} />
        <Box sx={{ fontSize: '14px', color: '#98A2B3' }}>Push only</Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Label
        labelName="Mode"
        isAdvanced
        sx={{ mb: 0 }}
        labelStyle={{
          fontSize: '14px',
          color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
          fontWeight: 400,
        }}
      />
      <ToggleButtonGroup
        value={mode}
        exclusive
        onChange={(_, newMode: ThirdPartyMode | null) => {
          if (newMode) onChange(newMode);
        }}
        disabled={disabled}
        size="small"
        sx={{
          '& .MuiToggleButton-root': {
            color: user?.theme === 'dark' ? '#98A2B3' : '#667085',
            borderColor: user?.theme === 'dark' ? '#475467' : '#D0D5DD',
            '&.Mui-selected': {
              backgroundColor: user?.theme === 'dark' ? '#667085' : '#D0D5DD',
              color: user?.theme === 'dark' ? '#F9FAFB' : '#101828',
            },
          },
        }}
      >
        <ToggleButton value="pull">Pull</ToggleButton>
        <ToggleButton value="push">Push</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default ModeToggle;
